<template>
  <el-popover placement="bottom" title="" :width="400" trigger="click">
    <div class="lang-popper-content">
      <div class="type-title">{{ $t("texts.language") }}</div>
      <div class="language-btn">
        <el-button
          v-for="languageItem in languageList"
          :key="languageItem.value"
          :plain="languageItem.value != willCurrentLocale"
          @click="() => toggleLocale(languageItem)"
          :type="willCurrentLocale == languageItem.value ? 'primary' : undefined"
          class="base-ui-info"
          >
          {{ languageItem.text }}
        </el-button>
      </div>
      <div class="type-title mt-12">{{ $t("texts.currency") }}</div>
      <div class="currency-btn">
        <el-button
          v-for="currencyItem in store.currencyList"
          :key="currencyItem.toCurrencyCode"
          @click="() => toggleCurrency(currencyItem)"
          :type="
            currencyItem.toCurrencyCode == willCurrentCurrency.toCurrencyCode
              ? 'primary'
              : undefined
          "
          :plain="
            currencyItem.toCurrencyCode != willCurrentCurrency.toCurrencyCode
          "
          class="base-ui-info"
          >{{ currencyItem.toCurrencyCode }}(1:{{currencyItem.exchangeRate}})</el-button>
      </div>
      <el-button
        type="primary"
        @click="submit"
        class="base-ui-primary block w-full mt-12px"
        >{{ $t("actions.ok") }}</el-button>
    </div>
    <template #reference>
      <div @click="openLocalePopover" class="switch-wrapper ml-10px">
        <el-icon class="icon-language">
          <MapLocation />
        </el-icon>
        <span class="current-locale">{{ localeText }}</span>
        <span v-if="get(store, 'currentCurrency.toCurrencyCode')">- {{ get(store, "currentCurrency.toCurrencyCode") }}</span>
        <el-icon class="icon-left">
          <ArrowLeft />
        </el-icon>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { MapLocation, ArrowLeft } from "@element-plus/icons-vue";
import { ref, onMounted, onBeforeMount, computed, watch } from "vue";
import { useMainStore } from "~/composables/store";
import { Menu, Search, Close } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { get,find } from "lodash-es";
import { $t } from "~/utils/index.js";
const { locales,getLocaleCookie, setLocaleCookie ,setLocale } = useI18n()
const store = useMainStore();
const show = ref(true);

 
const currentCurrency = ref(
  store.currentCurrency ? store.currentCurrency : {}
);
const willCurrentCurrency = ref(
  store.currentCurrency ? store.currentCurrency : {}
);

const languageList =computed(()=>{
  return [
    {
      text: $t("texts.chinaCn"),
      value: "zh-CN",
    },
    {
      text: $t("texts.chinaTw"),
      value: "zh-TW",
    },
    {
      text: $t("texts.en"),
      value: "en",
    },
    {
      text: $t("texts.vi"),
      value: "vi_VN",
    },
    {
      text: $t("texts.ja"),
      value: "ja_JP",
    },
  ];
});
const willCurrentLocale = ref(getLocaleCookie());
const currentLocale = ref(getLocaleCookie());

const name = "LocaleCurrencyChange";

const localeText=computed(()=>{
  let res="";
  let findItem= find(languageList.value,(o)=>o.value==currentLocale.value);
  if(findItem){
    res=findItem.text;
  }
  return res;
});

function toggleCurrency(toCurrency) {
  willCurrentCurrency.value = toCurrency;
}

function toggleLocale(toLocale) {
 
  willCurrentLocale.value = toLocale.value;
}

function openLocalePopover(){
  store.getCurrencyData();
}
function submit() {
  currentLocale.value=willCurrentLocale.value;
  currentCurrency.value = willCurrentCurrency.value;
  setLocale(willCurrentLocale.value);
  setLocaleCookie(willCurrentLocale.value);
  store.saveCurrentCurrency(currentCurrency.value);
  document.body.click();
 // window.location.reload();
}
</script>

<style scoped lang="less">
.lang-popper-content {
  padding: 10px;
}
.switch-wrapper.is-show {
  background-color: var(--bg);
}

.switch-wrapper.is-show .icon-left {
  transform: rotate(90deg);
}

.switch-wrapper:hover {
  background-color: var(--bg);
}

.switch-wrapper .icon-language {
  color: var(--text-01);
  font-size: 20px;
}

.switch-wrapper .icon-left {
  color: var(--text-01);
  font-size: 18px;
  transform: rotate(-90deg);
  transition: transform 0.1s linear;
}

.lang-popper-content .type-title {
  font-size: 14px;
  line-height: 30px;
}

.lang-popper-content .currency-btn,
.lang-popper-content .language-btn {
  display: grid;
  gap: 8px 4px;
  grid-template-columns: repeat(2, 1fr);
}

.lang-popper-content .currency-btn .el-button,
.lang-popper-content .language-btn .el-button {
  font-size: 12px;
  height: 32px;
  padding: 8px;
}

.lang-popper-content .currency-btn .el-button + .el-button,
.lang-popper-content .language-btn .el-button + .el-button {
  margin-left: 0;
}

.switch-wrapper {
  align-items: center;
  border-radius: 40px;
  -moz-column-gap: 4px;
  column-gap: 4px;
  cursor: pointer;
  display: flex;
  height: 44px;
  padding: 0 8px;
  position: relative;
  white-space: nowrap;
  >.icon-language{
    color:#000;
    &:before{
      display:none;
    }
  }
  >.icon-left{
    color:#000;
    &:before {
      display:none;
    }
  }
}
.current-locale {
  display: inline-block;
  white-space: nowrap;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
